import { render } from "./GalleryAddItemSection.vue?vue&type=template&id=c27bd69c"
import script from "./GalleryAddItemSection.vue?vue&type=script&lang=js"
export * from "./GalleryAddItemSection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c27bd69c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c27bd69c', script)) {
    api.reload('c27bd69c', script)
  }
  
  module.hot.accept("./GalleryAddItemSection.vue?vue&type=template&id=c27bd69c", () => {
    api.rerender('c27bd69c', render)
  })

}

script.__file = "resources/js/Pages/Station/Gallery/GalleryAddItemSection.vue"

export default script